import { createSlice } from "@reduxjs/toolkit";
// ⚠️ Deep-imports the DESKTOP variant on purpose — hazard 6.
import { supportLogout, userLogout } from "../LoginSlice";
import { sharedInitialState, sharedReducers } from "./shared";

// Dead in BOTH apps — `initialState` is not annotated with it and nothing imports it (it is
// not exported). Kept verbatim because `--verify` compares type declarations, and spelled out
// rather than `extends SharedInventoryState` because the apps declare it as a TYPE ALIAS and
// the analyser does not follow aliases. Zero runtime effect; a cleanup candidate, not uplift
// work.
type InventorySlice = {
    inventoryData: any[]
}

const initialState = {
    ...sharedInitialState,
}

export const inventorySlice = createSlice({
    name: 'inventorySlice',
    initialState,
    reducers: {
        ...sharedReducers,
        // ⚠️ Diverges from mobile ON PURPOSE: web MERGES into the existing value (and in
        // doing so turns the initial `[]` into a plain object), mobile REPLACES. See ./shared.
        saveInventoryData: (state, action) => {
            state.inventoryData = { ...state.inventoryData, ...action.payload }
        }
    },
    // Both bodies are empty in the app source — the cases exist but reset nothing.
    extraReducers: (builder) => {
        builder
            .addCase(userLogout, (state) => {

            })
            .addCase(supportLogout, (state) => {

            });
    },
})

export const {
    getInventoryData,
    saveInventoryData
} = inventorySlice.actions;

export default inventorySlice.reducer
